AchExceptionReviewModalController.$inject = ['$scope', '$modalInstance', 'achExceptions'];

export default function AchExceptionReviewModalController($scope, $modalInstance, achExceptions) {
    // variables
    $scope.form = null;
    $scope.achExceptions = achExceptions;

    // functions
    $scope.save = save;
    $scope.cancel = cancel;
    $scope.setForm = setForm;

    // public functions
    function save() {
        $modalInstance.close($scope.achExceptions);
    }

    function cancel() {
        $modalInstance.dismiss();
    }

    function setForm(form) {
        $scope.form = form;
    }

    // private functions
}
